import { render, staticRenderFns } from "./PortForwardingPage.vue?vue&type=template&id=1be6e56a&scoped=true"
import script from "./PortForwardingPage.vue?vue&type=script&lang=js"
export * from "./PortForwardingPage.vue?vue&type=script&lang=js"
import style0 from "./PortForwardingPage.vue?vue&type=style&index=0&id=1be6e56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be6e56a",
  null
  
)

export default component.exports